import React from "react";


function Footer() {
  return (
    <footer className="footer">
      <span>Employee Directory ©</span>
    </footer>
  );
}

export default Footer;
